import React, { useEffect, useState } from 'react'
import { IProduct, ProductInfo } from '../../interfaces/product';
import { useNavigate } from 'react-router-dom';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import Table from '../UI/CommonTable/CommonTable';

const LowQuantityProduct: React.FC = () => {
    const [products, setProducts] = useState<IProduct[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const navigate = useNavigate()

    useEffect(() => {
        getProducts();
    }, []);
    const getProducts = async (page: number = 1) => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + `products?page=${page}&sortType=ASC&isLowQuantity=true`, { method: 'GET' });
            const { data } = response;
            setProducts(data);
        } catch (error: any) {
            console.error('Failed to fetch products:', error.message);
        } finally {
            setLoading(false);
        }
    };



    const columns = [
        {
            header: "Image",
            accessor: "images",
            render: (images: string[]) => <div className='table-image'>
                <img className="img-image" src={images && images[0]} alt="" />
            </div>,
        },
        { header: "Title", accessor: "title" },
        {
            header: "Type Of Meat",
            accessor: "typeOfMeat",
            render: (types: string[]) => types.join(", "),
        },
        { header: "Cut", accessor: "cut" },
        { header: "Price (BHD)", accessor: "productInfo", render: (productInfo: ProductInfo[]) => productInfo && productInfo[0]?.price },
        { header: "Weight", accessor: "productInfo", render: (productInfo: ProductInfo[]) => productInfo && productInfo[0]?.pieceWeight },
        { header: "Available Stock", accessor: "productInfo", render: (productInfo: ProductInfo[]) => productInfo && productInfo[0]?.quantity },
    ];

    const actions = [
        {
            icon: "bi bi-pen",
            color: "success",
            onClick: (product: IProduct) => navigate(`/edit-product/${product.id}`),
        },
    ];

    return (
        <>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">Low Quantity Alerts</h1>
            </div>
            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                <div className="app-card-body">
                    <Table
                        columns={columns}
                        data={products}
                        loading={loading}
                        actions={actions}
                        emptyMessage="No products available."
                    />
                </div>
            </div>
        </>
    );
};


export default LowQuantityProduct